define('view/controller/booking/result/BookingResultView',['require','marionette','view/controller/booking/result/BookingResultItemView','view/controller/booking/result/BookingResultEmptyView','Config'],function (require) {
	
	var Marionette = require('marionette');
	var BookingResultItemView = require('view/controller/booking/result/BookingResultItemView');
	var BookingResultEmptyView = require('view/controller/booking/result/BookingResultEmptyView');
	var Config = require('Config');

	/**
	 * Client bookings list
	 * 
	 * @class BookingResultView
	 */
	return Marionette.CollectionView.extend({

	    childView: BookingResultItemView,
		emptyView: BookingResultEmptyView,
		childViewOptions: function (model, index) {
	    	var data = this.getOption('data');
	    	var highlighted = false;
	    	if (_.contains(data.highlighted, model.get('id'))) {
                highlighted = true;
			}
			return {
				clientTimeZone: this.getOption('clientTimeZone'),
                highlighted: highlighted,
				wl: !!parseInt(data.wl),
			};
		},
		collectionEvents: {
			'sync': 'render',
            'remove': '_onCancelSuccess'
		},
        
        _onCancelSuccess: function () {
            this.triggerMethod('cancel:success');
        },
        
		initialize: function () {
	    	this.listenTo(this.collection, 'sync', this.onCollectionSync);

			if (parseInt(Config.getInstance().getOption('show_booking_page_in_client_timezone'))) {
				if (this.getOption('clientTimeZone') && this.getOption('clientTimeZone').isNew()) {
					this.getOption('clientTimeZone').fetch();
				}
			}
			if (this.getOption('data') && this.getOption('data').booking_ids) {
				this.emptyView = null;
			}
		},

		onCollectionSync: function () {
			var data = this.getOption('data');
			if (data.cancelBookingId) {
				var model = this.collection.get(data.cancelBookingId);
				if (model) {
					this.children.findByModel(model).cancelBookingDialog();
				}
			}
		},

		filter: function (child, index, collection) {
			var ids = this.getOption('data').booking_ids;
			if (ids && ids.indexOf(child.get('id')) === -1) {
				return false;
			}
			return true;
		}

	});
	
});
